import { render, staticRenderFns } from "./lawyerPopup.vue?vue&type=template&id=22796116&scoped=true&"
import script from "./lawyerPopup.vue?vue&type=script&lang=js&"
export * from "./lawyerPopup.vue?vue&type=script&lang=js&"
import style0 from "./lawyerPopup.vue?vue&type=style&index=0&id=22796116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22796116",
  null
  
)

export default component.exports